import useEmailEditor from '@hooks/useEmailEditor';
import useSelectedElement from '@hooks/useSelectedElement';
import { useEventCallback } from '@mui/material';
import { useEffect } from 'react';
import { Path } from 'slate';
import { ReactEditor, useSlate } from 'slate-react';

const useHover = (element, target) => {
    const { hoveringPath, setHoveringPath } = useEmailEditor();
    const editor = useSlate();
    const path = ReactEditor.findPath(editor, element);

    const isHovering = hoveringPath && Path.equals(hoveringPath, path);

    const { getSelectedElement, setSelectedElement } = useSelectedElement();
    const [selectedNode, selectedPath] = getSelectedElement();
    const isSelected = selectedPath && Path.equals(selectedPath, path);

    const handleMouseOver = useEventCallback(e => {
        e.stopPropagation();
        setHoveringPath(path);
    });

    const handleMouseLeave = useEventCallback(e => setHoveringPath(null));

    const handleSelect = useEventCallback(e => {
        if (!isHovering) return;
        e.preventDefault();
        e.stopPropagation();
        setSelectedElement(path);
    });

    const hasTarget = Boolean(target);

    useEffect(() => {
        const elementTarget = target || ReactEditor.toDOMNode(editor, element);

        elementTarget.addEventListener('mouseover', handleMouseOver);
        elementTarget.addEventListener('mouseleave', handleMouseLeave);

        if (element.type === 'section') {
            elementTarget.addEventListener('mousedown', handleSelect);
        }

        return () => {
            elementTarget.removeEventListener('mouseover', handleMouseOver);
            elementTarget.removeEventListener('mouseleave', handleMouseLeave);
            if (element.type === 'section') {
                elementTarget.removeEventListener('mousedown', handleSelect);
            }
        };
    }, [hasTarget]);

    return { isHovering, isSelected };
};

export default useHover;
